/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { authReducer } from './src/redux/auth.slice';
import { authModalReducer } from './src/redux/authModal.slice';

// Redux
export { authModalActions, type AuthModalState } from './src/redux/authModal.slice';
export type { AuthAccount, AuthSession, AuthSliceState } from './src/redux/auth.slice';
export const authReducers = {
    authModal: authModalReducer,
    // Later key wins over sarsaparilla's `auth` loginReducer when public
    // stores spread `{...sarsaparillaReducers, ...authReducers}`.
    auth: authReducer,
};
